import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Check } from "lucide-react";
import { api } from "@/lib/api";
import { Card } from "@/components/panel";

const sameSet = (a, b) => a.length === b.length && a.every((x) => b.includes(x));

export const FortalezasSelector = ({ informe, onSaved }) => {
  const [sel, setSel] = useState(informe.seleccion_inicial || []);
  const [saving, setSaving] = useState(false);
  useEffect(() => { setSel(informe.seleccion_inicial || []); }, [informe]);

  const loaded = (informe.areas || []).length > 0;
  const dirty = informe.pendiente_revision || !sameSet(sel, informe.publicas || []);
  const toggle = (e) => setSel(sel.includes(e) ? sel.filter((x) => x !== e) : [...sel, e]);
  const save = async () => {
    setSaving(true);
    try {
      const ordered = informe.areas.filter((a) => sel.includes(a));
      await api.put("/egresado/fortalezas-visibles", { fortalezas_visibles: ordered });
      toast.success("Selección guardada: ya es visible en tu perfil público"); onSaved();
    } catch (err) { toast.error(err.response?.data?.detail || "No se pudo guardar la selección"); }
    finally { setSaving(false); }
  };

  if (!loaded) return <Card data-testid="fortalezas-card"><p className="text-sm text-[var(--brand-text-muted)]">Cargando fortalezas…</p></Card>;
  return (
    <Card data-testid="fortalezas-card">
      <h3 className="font-heading font-bold text-[var(--brand-primary)]">Soft skills (fortalezas)</h3>
      <p className="text-sm text-[var(--brand-text-muted)] mt-1 mb-4">
        Elegí qué fortalezas mostrar en tu perfil público. Las marcadas con <b>✓ informe</b> las respalda tu informe Human AI. Podés destildarlas o sumar otras. Nada se publica hasta que toques <b>Guardar mi selección</b>, y nunca se muestran debilidades.
      </p>
      {informe.pendiente_revision && (
        <div className="mb-4 rounded-xl bg-[var(--brand-surface)] px-4 py-3 text-sm text-[var(--brand-primary)]" data-testid="fortalezas-pendiente">
          Pre-marcamos las fortalezas que respalda tu informe. Revisalas y guardá tu selección para publicarlas.
        </div>
      )}
      <div className="divide-y divide-slate-100">
        {informe.areas.map((area) => {
          const on = sel.includes(area);
          return (
            <label key={area} className="flex items-center justify-between gap-3 py-3 cursor-pointer" data-testid={`fortaleza-row-${area}`}>
              <span className="text-sm text-[var(--brand-primary)] flex items-center gap-2 flex-wrap">
                {area}
                {informe.respaldadas.includes(area) && <span className="chip chip-accent" data-testid={`fortaleza-respaldada-${area}`}>✓ informe</span>}
              </span>
              <span className={`h-6 w-6 shrink-0 rounded-md border-2 flex items-center justify-center transition-colors ${on ? "bg-[var(--brand-accent)] border-[var(--brand-accent)] text-white" : "border-[var(--brand-border)]"}`}>
                {on && <Check size={14} />}
              </span>
              <input type="checkbox" className="sr-only" checked={on} onChange={() => toggle(area)} data-testid={`fortaleza-check-${area}`} />
            </label>
          );
        })}
      </div>
      <div className="flex flex-wrap items-center gap-3 mt-5">
        <button onClick={save} disabled={saving || !dirty} className="btn-primary disabled:opacity-50" data-testid="fortalezas-save">
          {saving ? "Guardando…" : "Guardar mi selección"}
        </button>
        <span className="text-xs text-[var(--brand-text-muted)]" data-testid="fortalezas-publicadas-count">
          {(informe.publicas || []).length} publicada(s) · {sel.length} seleccionada(s){dirty ? " · cambios sin guardar" : ""}
        </span>
      </div>
    </Card>
  );
};
